import flatObject from '@/utils/flatObject/flatObject';
import yamlTranslations from './es.yml';

export default flatObject(yamlTranslations);
